/**
 * Miscellaneous incident report — organization → home display name → Facility.Id (pharmacy scope).
 * Source: internal mapping / Streamlit; IDs must match dbo.Facility for the target pharmacy.
 */

/** Pharmacy that owns Facility.Id values in {@link MISC_INCIDENT_ORGANIZATION_FACILITIES}. */
export const MISC_REPORT_PHARMACY_ID = 3;

/** Organization → home label → Facility.Id (pharmacy scope). */
export const MISC_INCIDENT_ORGANIZATION_FACILITIES: {
  [organization: string]: { [homeName: string]: number };
} = {
  'Independent Homes': {
    'St Jacobs Place': 30,
    'Bethany Care Home': 41,
    'Craigwiel Gardens': 35,
    'Iroquois Lodge': 37,
    'John Noble Home': 60,
    'Royal Oak': 31,
    'Sandy Town': 38,
    'West Perth Village': 61,
    'Test Home': 16
  },
  'Lev Living': {
    'Aberdeen Gardens': 33,
    'Caroline Place': 32,
    'Winchester Glen': 58
  },
  'Elgin County': {
    'Bobier Villa': 55,
    'Elgin Manor': 54,
    'Terrace Lodge': 53
  },
  'Huron County': {
    'Huronlea': 57,
    'Huronview': 56
  },
  'Lifetime Living': {
    'Atrium': 50,
    'Devonshire': 39,
    'Lifetimes on Riverside': 40,
    'Maple Court': 45,
    'Mayfield': 51,
    'Oxford Manor': 46,
    'Park Place': 48,
    'Peterborough': 42,
    'The Manor at Gravenhurst': 49,
    'The Millwood': 43,
    'The Teddington': 44,
    'Tillsonburg': 47,
    'Willoughby Manor': 52
  }
};

/** Fixed sidebar order (matches typical grouping workflow). */
export function getMiscIncidentOrganizationNames(): string[] {
  return [
    'Independent Homes',
    'Lev Living',
    'Elgin County',
    'Huron County',
    'Lifetime Living'
  ];
}
